import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

interface ProductListHideFilterStateModel {
    isLoading: boolean;
    toggleData: boolean;
}
const initialState: ProductListHideFilterStateModel = {
    isLoading: true,
    toggleData: false,
};

const customProductListHideFilterReducer = createTypedReducerWithImmer(initialState, {
    "Custom/ProductList/SetToggleValue": (
        draft: Draft<ProductListHideFilterStateModel>,
        action: {
            toggle: boolean;
        },
    ) => {
        draft.toggleData = action.toggle;
    },
});

(reducers as any).customProductListHideFilterReducer = customProductListHideFilterReducer;

export type ProductListHideFilterState = {
    customProductListHideFilterReducer: ProductListHideFilterStateModel;
} & ApplicationState;

type Reducers = {
    customProductListHideFilterReducer: typeof customProductListHideFilterReducer;
};

export type ProductListHideFilterActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
